import { API } from "./api";

export const authApi = {
  login: (username, password) => API.post("/auth/login", { username, password }),
  me: () => API.get("/auth/me"),
};
